export default __webpack_public_path__ + "static/media/Raincoat.376a8ef2.png";